
<div [ngClass]="&quot;role &quot; + cssClass + (stacking ? &quot; vertical&quot; : &quot; horizontal&quot;) + &quot; &quot; + extraCss" [hidden]="hidden"><span>{{ text }}</span>
  <div *ngIf="multi" [ngClass]="&quot;expandable-container &quot; + expandDirection + &quot; contains-&quot; + expandableRoleList.length">
    <div *ngFor="let it of expandableRoleList" [ngClass]="&quot;expandable &quot; + it.cssClass"> <span>{{ it.abbreviation }}</span>
    </div>
  </div>
</div>